module.exports = __webpack_public_path__ + "static/media/mc-bg.f33438d1.jpg";